import { Injectable } from "@angular/core";
import { Store, select } from "@ngrx/store";

import { State } from "../reducers";
import {
  selectError,
  selectLoading,
  selectToken,
  selectJwtToken,
  selectIsAuthenticated,
  selectUsername
} from "../selectors";
import { Login, Logout, ReloadToken } from "../actions";
import { NotificationService } from "src/app/shared/services/notification/notification.service";

@Injectable({ providedIn: "root" })
export class AuthFacade {
  error$ = this.store.pipe(select(selectError));
  loading$ = this.store.pipe(select(selectLoading));
  isAuthenticated$ = this.store.pipe(select(selectIsAuthenticated));
  token$ = this.store.pipe(select(selectToken));
  jwt$ = this.store.pipe(select(selectJwtToken));
  username$ = this.store.pipe(select(selectUsername));

  constructor(private store: Store<State>, private notificationService: NotificationService) {}

  login() {
    this.store.dispatch(new Login());
  }

  restoreSession() {
    this.store.dispatch(new ReloadToken())
  }

  logout(returnUrl?: string) {
    this.notificationService.removeAllToast();
    this.store.dispatch(new Logout({ returnUrl }));
  }
}
